<template>
	<div class="page-login layout-full page-dark">
		<div class="page h-full">
			<div class="page-content h-full">
				<div class="page-brand-info vertical-align animation-slide-left d-none d-sm-block">
					<div class="page-brand vertical-align-middle">
						<div class="brand">
							<!-- <img class="brand-img" src="../../public/images/logo.png" height="70" alt /> -->
						</div>
						<h2 class="title">路小卫智能管理系统</h2>
					</div>
				</div>
				<div class="page-login-main animation-fade">
					<div class="vertical-align">
						<div class="vertical-align-middle">
							<div class="brand text-center">
								<!-- <img class="brand-img" src="../../public/images/logo.png" height="70" alt /> -->
							</div>
							<form class="login-form" action method="post" id="loginForm">
								<div class="form-group">
									<el-input placeholder="请输入账号" maxlength="11" v-model="form_data.user_name"
										v-on:input="checkNumber(form_data.user_name)"></el-input>
								</div>
								<div class="form-group">
									<el-input placeholder="请输入密码" type="password" v-model="form_data.passWord"
										v-on:input="checkPwd(form_data.passWord)"></el-input>
								</div>
								<el-button v-on:click="Login" type="primary" :loading="loading"
									class="login-btn dis-flex flex-middle flex-center cursor">立即登录</el-button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			form_data: {
				user_name: "",
				passWord: "",
			},
		};
	},
	methods: {
		checkNumber(val) {
			this.form_data.user_name = val;
		},
		checkPwd(val) {
			this.form_data.passWord = val;
		},
		Login() {
			const that = this;
			that.loading = true;
			if (that.form_data.user_name === "") {
				that.$message({
					type: "error",
					message: `操作提示: ${"账号不能为空"}`,
				});
				that.loading = false;
				return;
			}
			if (that.passWord === "") {
				that.form_data.$message({
					type: "error",
					message: `操作提示: ${"请您输入密码"}`,
				});
				that.loading = false;
				return;
			}
			that.axios.post("/login", {
				username: that.form_data.user_name,
				password: that.form_data.passWord,
			})
				.then((res) => {
					console.log(res);
					if (res.code == 200) {
						sessionStorage.setItem("access-token", res.data);
						that.$message.success(res.msg);
						this.$router.push("/index");
					} else {
						that.loading = false;
						that.$message.error(res.msg);
					}
				});
		},
	},
};
</script>

<style>
body {
	margin: 0;
	font-family: "Roboto", sans-serif;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.57142857;
	color: #76838f;
	text-align: left;
	background-color: #fff;
}

*,
*::before,
*::after {
	box-sizing: border-box;
}

.page-dark.layout-full::after {
	position: fixed;
	top: 0;
	left: 0;
	z-index: -1;
	width: 100%;
	height: 100%;
	content: "";
	background-color: rgba(38, 50, 56, 0.6);
}

.page-dark.layout-full {
	z-index: 0;
	color: #fff;
}

.page-login {
	height: 100%;
	min-height: 540px;
	overflow: hidden;
	padding-top: 0;
}

.layout-full {
	height: 100%;
	padding-top: 0 !important;
}

.page-login .page {
	background: transparent;
}

.vertical-align {
	font-size: 0;
}

.layout-full .page {
	height: 100%;
	padding: 0;
	margin: 0 !important;
	background-color: transparent;
}

.h-full {
	height: 100% !important;
}

.page-login .page-content {
	padding-right: 500px;
	position: absolute;
	width: 100%;
}

.page-content {
	padding: 20px 20px;
}

.page-login .page-brand-info {
	height: 100%;
}

.animation-slide-left {
	-webkit-animation-name: slide-left;
	animation-name: slide-left;
}

.page-login .page-brand-info .page-brand {
	padding: 0 60px 60px;
}

.vertical-align-middle {
	vertical-align: middle;
}

.vertical-align-middle,
.vertical-align-bottom {
	display: inline-block;
	max-width: 100%;
	font-size: 1rem;
}

.page-dark.layout-full .brand {
	margin-bottom: 22px;
}

.page-login .page-brand-info .page-brand h2 {
	color: #fff;
	max-width: 650px;
}

.page-dark.layout-full::before {
	position: fixed;
	top: 0;
	left: 0;
	z-index: -1;
	width: 100%;
	height: 100%;
	content: "";
	background-position: center top;
	background-size: cover;
}

.page-login:before {
	background-image: url(../../public/images/login.jpg);
}

.page-content> :not(script):last-child {
	margin-bottom: 0 !important;
}

.page-login-main {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	min-height: 540px;
	padding: 150px 60px 180px;
	padding: 0 60px;
	color: #76838f;
	background: #fff;
}

.page-login-main .vertical-align {
	height: 100%;
	box-sizing: border-box;
	padding-bottom: 65px;
}

.vertical-align {
	font-size: 0;
}

.vertical-align:before {
	display: inline-block;
	height: 100%;
	vertical-align: middle;
	content: "";
}

.vertical-align-middle {
	vertical-align: middle;
}

.vertical-align-middle,
.vertical-align-bottom {
	display: inline-block;
	max-width: 100%;
	font-size: 1rem;
}

.page-login .login-form {
	width: 350px;
	margin: 45px 0 20px;
}

.form-group {
	margin: 30px 0;
}

.login-btn {
	width: 100%;
}

.text-center {
	text-align: center;
}
</style>